import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { Box, Container, Paper, Typography, Button, CircularProgress, Alert } from '@mui/material';
import authService from '../utils/authService';
import { loginSuccess } from '../redux/slices/authSlice';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const run = async () => {
      try {
        const response = await authService.verifyEmail(token);
        setSuccess(true);
        
        // Si le backend renvoie l'utilisateur (connexion auto), on met à jour le store Redux
        const user = response.data?.user || response.data?.data?.user;
        if (user) {
          dispatch(loginSuccess({ user }));
          setUserRole(user.role);
          
          // Redirection automatique après 3 secondes
          setTimeout(() => {
            if (user.role === 'organization') {
              navigate('/dashboard/org');
            } else {
              navigate('/dashboard');
            }
          }, 3000);
        }
      } catch (e) {
        setError(e.message || 'Erreur lors de la vérification');
      } finally {
        setLoading(false);
      }
    };
    if (token) run();
  }, [token, dispatch, navigate]);

  const handleContinue = () => {
    if (userRole === 'organization') {
      navigate('/dashboard/org');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <>
      <Helmet>
        <title>Vérification de l'email - Mission Sport</title>
        <meta name="description" content="Vérification de votre adresse email pour activer votre compte Mission Sport." />
      </Helmet>
      <Box sx={{ py: 6 }}>
        <Container maxWidth="sm">
          <Paper sx={{ p: 4, textAlign: 'center' }} elevation={3}>
            {loading && (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <CircularProgress />
                <Typography>Vérification en cours...</Typography>
              </Box>
            )}

            {!loading && success && (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <Alert severity="success" sx={{ width: '100%' }}>Email vérifié avec succès</Alert>
                <Typography>Votre compte est maintenant activé. Vous allez être redirigé vers votre tableau de bord...</Typography>
                <Button variant="contained" onClick={handleContinue}>Accéder à mon compte</Button>
              </Box>
            )}

            {!loading && !success && (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <Alert severity="error" sx={{ width: '100%' }}>{error || "Lien de vérification invalide ou expiré"}</Alert>
                <Typography>Vous pouvez demander un nouvel email de vérification depuis votre espace.</Typography>
                <Button component={Link} to="/login" variant="outlined">Aller à la connexion</Button>
              </Box>
            )}
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default VerifyEmail;